import React, { Component } from 'react'
import { Button, Checkbox, Tooltip, message, Popover } from 'antd'
import FilterTable from '@/components/FilterTable';
import WeekTocreate from '@/views/workList/ovhideen'
import { reqByGet, reqByPost, reportSave } from '@/api/api';
import servers from '@/api/server'
import { Record } from 'immutable';
import './statistical.css'
class workList extends Component {
    constructor(props) {
        super(props)
        this.checkSpan = null
        this.state = {
            total: 0,
            current: 1,
            loading: false,
            isCreader: false,
            isIcon: false,
            list: [],
            listAll: [],
        }
    }
    componentDidMount() {
        this.getData({ status: 1 })
    }
    getData(values = {}) {
        const that = this;
        this.setValue('loading', true)
        reqByGet(servers.backlogListDataList, { ...values }, res => {
            console.log(res)
            that.setState({
                total: res.total,
                list: res.rows || [],
                listAll: res.rows || [],
                loading: false,
            })
        }, err => {
            that.setValue('loading', false)
            console.log(err)
        })
    }
    setValue = (file, falg) => {
        this.setState({
            [file]: falg
        })
    }
    handleSearch = (values) => {
        console.log(values)
        if (values.current) {
            this.setValue('current', values.current)
            return
        }

    }
    checkedOnchenge = (record) => {
        let status
        if (record.status == 1) {
            status = 2
        } else {
            status = 1
        }
        // this.checkSpan.parentNode.parentNode.parentNode.classList.add('caonimata')//ref  dom操作添加类
        // console.dir(this.checkSpan.parentNode.parentNode.parentNode)
        // return
        reqByGet(servers.backlogListSave, { id: record.id, status }, res => {
            if (res.statusCode !== 1000) {
                Modal.error({
                    content: res.message
                })
                return
            }
            message.success("修改成功")
            this.getData({ status: record.status })
        }, err => {
            console.log(err)
        })
    }
    render() {
        const { current, list, isIcon, total, isCreader, loading } = this.state
        const columns = [
            {
                title: '标题',
                dataIndex: 'content',
                align: 'left',
                width: '34%',
                onCell: () => {
                    return {
                        style: {
                            maxWidth: 30,
                            overflow: 'hidden',
                            whiteSpace: 'nowrap',
                            textOverflow: 'ellipsis',
                            cursor: 'pointer'
                        }
                    }
                },
                render: (text, record) => {
                    return (
                        <Tooltip placement="topLeft" title={text}>
                            <Checkbox
                                checked={isIcon}
                                onChange={e => {
                                    this.checkedOnchenge(record)
                                }}
                            >
                            </Checkbox>
                            <span ref={ref => this.checkSpan = ref}>&nbsp;&nbsp;<span style={{ lineHeight: "1.5" }} className={isIcon ? 'tdLT' : ''}>{record.content}</span></span>
                        </Tooltip>
                    )
                }
            }, {
                title: '标签',
                dataIndex: 'tagName',
                align: 'center',
                width: '25%',
                onCell: () => {
                    return {
                        style: {
                            maxWidth: 25,
                            overflow: 'hidden',
                            whiteSpace: 'nowrap',
                            textOverflow: 'ellipsis',
                            cursor: 'pointer'
                        }
                    }
                },
                render: (text, record) => {
                    return (
                        <Tooltip placement="topLeft" title={text}>
                            <span> {text}</span>
                        </Tooltip>
                    )

                }
            }, {
                title: '优先级',
                dataIndex: 'level',
                align: 'center',
                width: '16%',
                sorter: (a, b) => a.level - b.level,
                render: (text, record) => {
                    let selectV = ''
                    let cls = ''
                    switch (text) {
                        case 1:
                            selectV = 'High'
                            cls = 'c_red2'
                            break;
                        case 2:
                            selectV = 'Middle'
                            cls = 'c_8bff'
                            break;
                        case 3:
                            selectV = 'Low'
                            cls = 'c_8bff'
                            break;
                        default:
                            selectV = 'Nice To Have'
                            cls = 'c_8e'
                    }
                    return (
                        <span className={cls}>{selectV}</span>
                    )
                }
            }, {
                title: '结束时间',
                dataIndex: 'endDateTimeString',
                align: 'center',
                width: '25%',
                sorter: (a, b) => {
                    var stringA = a.endDateTimeString.toUpperCase(); // ignore upper and lowercase
                    var stringB = b.endDateTimeString.toUpperCase(); // ignore upper and lowercase
                    if (stringA < stringB) {
                        return -1;
                    }
                    if (stringA > stringB) {
                        return 1;
                    }
                },
                render: (text, record) => {
                    return (
                        <span>{text.substring(5, 16)}</span>
                    )
                }
            },
        ]
        return (
            <div className='shouyeTable'>
                <div className="tr" style={{ height: "26px" }}>
                    <Popover placement="bottom" content={<div>已完成</div>} className='mr20 msg listAll'>
                        <i className={`iconfont icon-yiwancheng1 cp f22 ${isIcon && 'c_8bff'}`} onClick={() => {
                            this.setState({
                                isIcon: !isIcon,
                                isCreader: false
                            })
                            this.getData({ status: isIcon ? 1 : 2 })
                        }}></i>
                    </Popover>
                    <Popover placement="bottom" content={<div>工作日历</div>} className='mr20 msg listAll'>
                        <i className={`iconfont icon-xinbaniconshangchuan- cp f24 ${isCreader && 'c_8bff'}`} onClick={() => {
                            this.setState({
                                isIcon: false,
                                isCreader: true
                            })
                        }}></i>
                    </Popover>
                </div>
                {!isCreader && <div className="tabel_wrapper_com">
                    <FilterTable
                        className='Table1'
                        columns={columns}
                        loading={loading}
                        // pageSize={2}
                        // simple={true}
                        dataFilter={this.handleSearch}
                        data={list}
                        total={total}
                        size={true}
                        current={current}
                    />
                </div>}
                {isCreader &&
                    <WeekTocreate />
                }
            </div>
        )
    }
}
export default workList
